import { render, staticRenderFns } from "./FSIThirdPartyIBSForm.vue?vue&type=template&id=a027835c&scoped=true"
import script from "./FSIThirdPartyIBSForm.vue?vue&type=script&lang=js"
export * from "./FSIThirdPartyIBSForm.vue?vue&type=script&lang=js"
import style0 from "./FSIThirdPartyIBSForm.vue?vue&type=style&index=0&id=a027835c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a027835c",
  null
  
)

export default component.exports